module.exports = __webpack_public_path__ + "static/media/md-folder-open.ba66422a.svg";